import { render, staticRenderFns } from "./ShipIcon.vue?vue&type=template&id=62097d69"
import script from "./ShipIcon.vue?vue&type=script&lang=js"
export * from "./ShipIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports